(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.Events.Calendar.CalendarView",
                    {
                        url: "/Calendar?view&date",
                        component: "calendarView",
                        PageTitle: "Event Calendar | Marketing Tracker",
                        params: {
                            view: {
                                dynamic: true
                            },
                            date: {
                                dynamic: true
                            }
                        },
                        resolve: {
                            user: ["userApi", function (userApi) {
                                return userApi.getLoggedInUser()
                                    .then(function (user) {
                                        return {
                                            UserId: user.Id,
                                            User: user
                                        };
                                    });
                            }],
                            onBehalfOfUser: ["userApi", "permissionService", function (userApi, permissionService) {

                                var onBehalfOfUserId = permissionService.getOnBehalfOfUserId();
                                if (onBehalfOfUserId)
                                    return userApi.get(onBehalfOfUserId).catch(ng.noop);

                                return null;
                            }]
                        }
                    });
        }
    ]);

    app
        .component("calendarView",
            {
                templateUrl: "App/Tools/MarketingTrackerNew/Events/Calendar/CalendarView/calendar-view-template.html",
                controller: calendarViewController,
                bindings: {
                    user: "<",
                    onBehalfOfUser: "<"
                }
            });

    calendarViewController.$inject = ["featureToggleService", "moment", "$scope", "$mdDialog", "uiCalendarConfig", "marketingTrackerAgentApi", "marketingPlanApi", "marketingTrackerApi", "marketingTrackerUserApi", "_", "$q", "marketingTrackerAuthService", "userApi", "marketingTrackerArcEventApi", "marketingTrackerEventTypeApi", "$window", "$state", "figToaster", "$location", "stateHistory"];
    function calendarViewController(featureToggleService, moment, $scope, $mdDialog, uiCalendarConfig, marketingTrackerAgentApi, marketingPlanApi, marketingTrackerApi, marketingTrackerUserApi, _, $q, marketingTrackerAuthService, userApi, marketingTrackerArcEventApi, marketingTrackerEventTypeApi, $window, $state, figToaster, $location, stateHistory) {
        var $ctrl = this;
        window.calendar = this;
        $ctrl.state = $state;
        $ctrl.location = $location;
        $ctrl.scope = $scope;
        ng.extend($ctrl,
            {
                environment: featureToggleService.checkEnv(),
                views: {
                    fromCalendar: {
                        listDay: "day",
                        basicWeek: "week",
                        month: "month"
                    },
                    fromUrl: {
                        day: "listDay",
                        week: "basicWeek",
                        month: "month"
                    }
                },
                getUserMarketingTrackerEventsForYear: getUserMarketingTrackerEventsForYear,
                eventCalendar: {
                    defaultView: "month",
                    now: moment().toISOString(),
                    height: "parent",
                    handleWindowResize: true,
                    customButtons: {
                        myCustomButton: {
                            text: "year",
                            click: function () {
                                $ctrl.ui.calendarView = "year";
                                var date = uiCalendarConfig.calendars.eventCalendar.fullCalendar("getDate");
                                stateHistory.setQuery({
                                    view: "year",
                                    date: date.format("YYYY-MM-DD")
                                });
                                $ctrl.startDate = date.add(1, "d").toDate();
                                $scope.$apply();
                            }
                        }
                    },
                    header: {
                        left: "listDay,basicWeek,month,myCustomButton today ",
                        center: "title",
                        right: "prev,next"
                    },
                    buttonText: {
                        listDay: "day"
                    },
                    viewRender: function (view) {
                        if (uiCalendarConfig.calendars.eventCalendar) {
                            var date = uiCalendarConfig.calendars.eventCalendar.fullCalendar("getDate");
                            if (date._isAMomentObject) {
                                stateHistory.setQuery({
                                    view: $ctrl.views.fromCalendar[view.type],
                                    date: date.format("YYYY-MM-DD")
                                });
                                $ctrl.startDate = date.add(1, "d").toDate();
                            }
                        }
                    },
                    validRange: function () {
                        var selectedYear = moment().year($ctrl.ui.selectedYear);
                        return {
                            start: selectedYear.startOf("year").format("YYYY-MM-DD"),
                            end: selectedYear.endOf("year").format("YYYY-MM-DD")
                        };
                    },
                    views: {
                        listDay: {
                            titleFormat: "dddd MMMM D, YYYY"
                        },
                        month: {
                            eventLimit: 4,
                            eventLimitClick: "popover"
                        }
                    },
                    eventClick: function (evt) {
                        var eventType = typeForEvent(evt, true);

                        if (eventType === "EventWithAttendees") {
                            // state Transition
                            $state.go("Home.Tools.MarketingTrackerNew.Events.EventView",
                                {
                                    "EventGroupId": evt.event.EventGroup.Id,
                                    "EventId": evt.event.EventId
                                });
                        } else {
                            // Display a Modal
                            // Eventually these will be put into their own state. 
                            // Note that Ancillary events are using the old editEventController not the one that an eventWithAttendees
                            var modal = null;
                            if (eventType === "FigEvent") {
                                // Modal Fig Event
                                modal = {
                                    templateUrl:
                                        "App/Tools/MarketingTracker/Calendar/ViewFigEvent/viewfigevent-template.html",
                                    controller: "viewFigEventController",
                                    controllerAs: "$ctrl",
                                    resolve: {
                                        event: evt.event,
                                        eventGroup: evt.eventGroup
                                    },
                                    bindToController: true
                                };
                            } else if (eventType === "Planning") {
                                // Planning Event State
                                if (evt.eventType.IsAncillary === true) {

                                    $state.go("Home.Tools.MarketingTrackerNew.Events.AncillaryPlanningEvent",
                                        {
                                            "EventGroupId": evt.event.EventGroup.Id,
                                            "EventId": evt.event.EventId
                                        });
                                } else {

                                    $state.go("Home.Tools.MarketingTrackerNew.Events.PlanningEvent",
                                        {
                                            "EventGroupId": evt.event.EventGroup.Id,
                                            "EventId": evt.event.EventId
                                        });
                                }
                            } else {
                                // Ancillary Event different state
                                $state.go("Home.Tools.MarketingTrackerNew.Events.AncillaryEvent",
                                    {
                                        "EventGroupId": evt.event.EventGroup.Id,
                                        "EventId": evt.event.EventId
                                    });
                            }
                            if (modal !== null) {
                                $mdDialog.show(modal)
                                    .then(function (response) {
                                        if (response && response.eventGroupId && response.toDelete) {

                                            var evGroupIndex = _.findIndex($ctrl.allMarketingTrackerEvents,
                                                function (row) {
                                                    return row.EventGroup.Id === response.eventGroupId &&
                                                        row.EventId === response.eventId;
                                                });

                                            if (evGroupIndex !== -1)
                                                $ctrl.allMarketingTrackerEvents.splice(evGroupIndex, 1);

                                        } else if (response && response.eventGroup) {

                                            var evGroup = _.find($ctrl.allMarketingTrackerEvents,
                                                function (row) {
                                                    return row.EventGroup.Id === response.eventGroup.Id &&
                                                        row.EventId === response.event.Id;
                                                });

                                            if (evGroup) {
                                                evGroup.EventDate = response.event.EventDate;
                                                evGroup.Title = response.eventGroup.EventType.Name === "Custom"
                                                    ? response.event.Description
                                                    : response.eventGroup.EventType.IsAncillary
                                                        ? response.eventGroup.EventType.Name
                                                        : response.event.Title;
                                            }
                                        }
                                        convertFullCalendarEvents();
                                        uiCalendarConfig.calendars.eventCalendar.fullCalendar("removeEvents");
                                        uiCalendarConfig.calendars.eventCalendar.fullCalendar("addEventSource",
                                            $ctrl.eventSource);
                                    })
                                    .catch(function (error) {
                                        console.log("Error: " + error.data);
                                        message = "There was a problem loading your events. Please try again shortly.";
                                        toastClass = "is-error";
                                        figToaster.showSimple(message, "top", toastClass);
                                    });
                            }
                        }
                    }
                },
                yearCalendar: {
                    contextMenuItems: [
                        {
                            text: "Update",
                            subMenu: [],
                            click: function (evt) {
                                return $mdDialog.show({
                                    templateUrl: "App/Tools/MarketingTracker/Calendar/EditEvent/editevent-template.html",
                                    controller: "editEventController",
                                    controllerAs: "$ctrl",
                                    locals: {
                                        eventGroup: evt.eventGroup,
                                        event: evt.event
                                    },
                                    bindToController: true
                                })
                                    .then(function (response) {
                                        if (response && response.eventGroupId && response.toDelete) {
                                            var evGroupIndex = _.findIndex($ctrl.allMarketingTrackerEvents,
                                                function (row) {
                                                    return row.EventGroup.Id === response.eventGroupId && row.EventId === response.eventId;
                                                });
                                            if (evGroupIndex !== -1)
                                                $ctrl.allMarketingTrackerEvents.splice(evGroupIndex, 1);
                                        }
                                        else if (response && response.eventGroup) {
                                            var evGroup = _.find($ctrl.allMarketingTrackerEvents,
                                                function (row) {
                                                    return row.EventGroup.Id === response.eventGroup.Id &&
                                                        row.EventId === response.event.Id;
                                                });
                                            if (evGroup) {
                                                evGroup.EventDate = response.event.EventDate;
                                                //evGroup.Title = response.event.Title;
                                                evGroup.Title = response.eventGroup.EventType.Name === "Custom" ? response.event.Description : response.eventGroup.EventType.IsAncillary ? response.eventGroup.EventType.Name : response.event.Title;
                                            }
                                        }
                                        convertFullCalendarEvents();
                                    })
                                    .catch(function () {
                                        console.log("Error: " + data);
                                        message = "There was a problem loading your events. Please try again shortly.";
                                        toastClass = "is-error";
                                    });
                            }
                        }
                    ],
                    minDate: moment().startOf("year").toDate(),
                    maxDate: moment().endOf("year").toDate(),
                    clickDay: function (elem) {
                        $ctrl.ui.calendarView = "day";
                        uiCalendarConfig.calendars.eventCalendar.fullCalendar("changeView",
                            "listDay", moment(elem.date));
                        $scope.$apply();
                        setTimeout(function () {
                                uiCalendarConfig.calendars.eventCalendar.fullCalendar("render");
                            },
                            100);
                    }
                },
                ui: {
                    loading: true,
                    calendarView: "month",
                    selectedYear: moment().year(),
                    isCurrentYear: true
                },
                years: [],
                eventSource: {
                    events: []
                },
                yearCalendarEvents: [],
                eventCounts: {},
                colorCodeEventTypes: colorCodeEventTypes,
                colorEvents: colorEvents,
                error: error,
                onEventAdded: onEventAdded,
                onTourClosed: onTourClosed
            });



        // watch selected year to update query string if it changes when year is the current calendar
        $scope.$watch(function() { return $ctrl.ui.selectedYear; },
            function(newValue) {
                if ($ctrl.ui.calendarView === "year") {
                    var params = $location.search();
                    var date = moment().year(newValue);
                    if (params.date) {
                        date = moment(params.date).year(newValue);
                    }

                    $ctrl.startDate = date.toDate();
                    stateHistory.setQuery({
                        view: "year",
                        date: date.format("YYYY-MM-DD")
                    });
                }
            });

        function typeForEvent(evt, checkForIsPlanning) {
            if (evt.eventType.Id === "Fig Event") return "FigEvent";
            else if (checkForIsPlanning && evt.event.IsPlanning) return "Planning";
            else if (evt.eventType.IsAncillary) return "Ancillary";
            else return "EventWithAttendees";
        }

        function error($event) {
            var errorMsg = $mdDialog.alert({
                title: "We're sorry, there was an error.",
                targetEvent: $event,
                ariaLabel: "Confirm event error",
                ok: "Yes",
                multiple: true,
                clickOutsideToClose: false
            });

            $mdDialog.show(errorMsg).then(function () {
                $mdDialog.hide({
                    eventGroup: $ctrl.eventGroup,
                    event: $ctrl.event
                });
                $window.location.reload();
            });
        }

        function colorCodeEventTypes() {
            $ctrl.eventTypes.forEach(function (e) {
                var hash = 0;
                for (var i = 0, len = e.Id.length; i < len; i++) {
                    var char = e.Id.charCodeAt(i);
                    hash = (hash << 5) - hash + char;
                    hash |= 0;
                }
                var color = {};
                color.a = Math.abs((hash & 0xff000000) >> 24);
                color.r = (hash & 0x00ff0000) >> 16;
                color.g = (hash & 0x0000ff00) >> 8;
                color.b = hash & 0x000000ff;
                var opacity = 0.4; // + ((color.a / 255) / 10);
                e.textcolor = "#1e1e1e";
                e.colorstyle = "rgba(" + color.r + "," + color.g + "," + color.b + "," + opacity + ")";
            });
        }

        function colorEvents() {

            $ctrl.eventSource.events.forEach(function (e) {
                var event = $ctrl.eventTypes.find(function (t) {
                    return t.Id === e.eventType.Id;
                });
                e.color = event.colorstyle;
                e.textColor = event.textcolor;
            });

            $ctrl.yearCalendarEvents.forEach(function (e) {
                var event = $ctrl.eventTypes.find(function (t) {
                    return t.Id === e.eventType.Id;
                });
                e.color = event.colorstyle;
                e.textColor = event.textcolor;
            });
        }

        function onTourClosed(response) {
            console.log("closed from component");
        }

        function onEventAdded(response) {
            if (response instanceof Array) {
                ng.forEach(response,
                    function (evtGroup) {
                        ng.forEach(evtGroup.Events,
                            function (event) {

                                $ctrl.eventSource.events.push({
                                    title: evtGroup.EventType.Name === "Custom"
                                        ? event.Description
                                        : evtGroup.EventType.IsAncillary
                                            ? evtGroup.EventType.Name
                                            : event.Title,
                                    //title: !!evtGroup.EventType.IsAncillary ? evtGroup.EventType.Name : event.Title,
                                    start: moment(event.EventDate).toISOString(),
                                    allDay: true
                                });

                                $ctrl.allMarketingTrackerEvents.push({
                                    EventGroup: evtGroup,
                                    //Title: !!evtGroup.EventType.IsAncillary ? evtGroup.EventType.Name : event.Title,
                                    Title: evtGroup.EventType.Name === "Custom"
                                        ? event.Description
                                        : evtGroup.EventType.IsAncillary
                                            ? evtGroup.EventType.Name
                                            : event.Title,
                                    EventDate: event.EventDate,
                                    EventType: evtGroup.EventType,
                                    EventId: event.Id,
                                    IsPlanning: event.IsPlanning
                                });
                            });
                    });
            } else {
                ng.forEach(response.Events,
                    function (event) {

                        $ctrl.eventSource.events.push({
                            //title: !!response.EventType.IsAncillary ? response.EventType.Name : event.Title,
                            title: response.EventType.Name === "Custom"
                                ? event.Description
                                : response.EventType.IsAncillary
                                    ? response.EventType.Name
                                    : event.Title,
                            start: moment(event.EventDate).toISOString(),
                            allDay: true
                        });

                        $ctrl.allMarketingTrackerEvents.push({
                            EventGroup: response,
                            //Title: !!response.EventType.IsAncillary ? response.EventType.Name : event.Title,
                            Title: response.EventType.Name === "Custom"
                                ? event.Description
                                : response.EventType.IsAncillary
                                    ? response.EventType.Name
                                    : event.Title,
                            EventDate: event.EventDate,
                            EventType: response.EventType,
                            EventId: event.Id,
                            IsPlanning: event.IsPlanning
                        });
                    });
            }

            convertFullCalendarEvents();
            calcEventCountsPerYear();
            uiCalendarConfig.calendars.eventCalendar.fullCalendar("removeEvents");
            uiCalendarConfig.calendars.eventCalendar.fullCalendar("addEventSource", $ctrl.eventSource);
        };

        function roundDate(timeStamp) {
            timeStamp -= timeStamp % (24 * 60 * 60 * 1000); //subtract amount of time (in ms) since midnight              
            timeStamp += new Date(timeStamp).getTimezoneOffset() * 60 * 1000; //add on the timezone offset         
            return new Date(timeStamp);
        }

        function convertFullCalendarEvents() {
            $ctrl.eventSource.events = [];
            $ctrl.yearCalendarEvents = [];

            ng.forEach($ctrl.allMarketingTrackerEvents,
                function (eventGroup) {

                    //for older events not showing up in year calendar, the roundDate function brings the date to the correct hour mark to display in year calendar                  
                    if (new Date(eventGroup.EventDate).getHours() > 0) {
                        eventGroup.EventDate = roundDate(eventGroup.EventDate);
                    }

                    $ctrl.eventSource.events.push({
                        //title: !!eventGroup.EventType.IsAncillary ? eventGroup.EventType.Name : eventGroup.Title,
                        //title: eventGroup.Title,
                        title: eventGroup.EventType.IsAncillary && eventGroup.IsPlanning && eventGroup.EventType.Name !== "Custom" ? "Planning - " + eventGroup.Title : eventGroup.Title,
                        start: moment(eventGroup.EventDate).toISOString(),
                        allDay: true,
                        eventGroup: eventGroup.EventGroup,
                        event: eventGroup,
                        eventType: eventGroup.EventType
                    });

                    $ctrl.yearCalendarEvents.push({
                        //name: !!eventGroup.EventType.IsAncillary ? eventGroup.EventType.Name : eventGroup.Title,
                        name: eventGroup.EventType.IsAncillary && eventGroup.IsPlanning && eventGroup.EventType.Name !== "Custom" ? "Planning - " + eventGroup.Title : eventGroup.Title,
                        startDate: new Date(eventGroup.EventDate),
                        endDate: new Date(eventGroup.EventDate),
                        eventGroup: eventGroup.EventGroup,
                        event: eventGroup,
                        eventType: eventGroup.EventType
                    });
                });

            colorEvents();
        }

        function calcEventCountsPerYear() {
            $ctrl.eventCounts = [];

            ng.forEach($ctrl.eventTypes,
                function (t) {
                    $ctrl.eventCounts[t.Name] = _.uniqBy(_.filter($ctrl.allMarketingTrackerEvents,
                        function (row) {
                            return row.EventType.Id === t.Id && !row.IsPlanning;
                        }),
                        function(row) {
                            return row.EventGroup.Id;
                        }).length;
                });
        }

        function getRecommendations() {
            return marketingTrackerAgentApi.get().catch(ng.noop).then(function (agent) {
                return marketingPlanApi
                    .getMarketingPlanByYear(agent.AgentId, $ctrl.ui.selectedYear)
                    .then(function (plan) {
                            return $ctrl.recommendations = plan.Recommendations;
                        }, function () {
                            return $ctrl.recommendations = [];
                        });
            });
        }

        function getMarketingTrackerFigAuthUserEvents(figAuthUserId, year, month, nextPageToken) {
            return marketingTrackerUserApi.getUserBasicEventsByDate(year, month, nextPageToken)
                .then(function (events) {

                    if (!events.NextPage)
                        return events;

                    return getMarketingTrackerFigAuthUserEvents(figAuthUserId, year, month, events.NextPage)
                        .then(function (recursiveEvents) {
                            return events = _.concat(events, recursiveEvents);
                        });
                });
        }

        function getMarketingTrackerFigAuthUserAncillaryEvents(figAuthUserId, year, month, nextPageToken) {
            return marketingTrackerUserApi.getUserBasicAncillaryEventsByDate(year, month, nextPageToken)
                .then(function (events) {

                    if (!events.NextPage)
                        return events;

                    return getMarketingTrackerFigAuthUserAncillaryEvents(figAuthUserId, year, month, events.NextPage)
                        .then(function (recursiveEvents) {
                            return events = _.concat(events, recursiveEvents);
                        });
                });
        }

        function getMarketingTrackerEventsForFigAuthUser(figAuthUserId, year, month) {

            var p1 = getMarketingTrackerFigAuthUserEvents(figAuthUserId, year, month);
            var p2 = getMarketingTrackerFigAuthUserAncillaryEvents(figAuthUserId, year, month);

            return $q.all([p1, p2])
                .then(function (results) {

                    var events = [];
                    ng.forEach(results,
                        function (r) {
                            events = _.concat(events, r);
                        });

                    return events;
                });
        }

        function getUserMarketingTrackerEventsForYear() {

            $ctrl.allMarketingTrackerEvents = [];
            var promises = [];

            var newDate = uiCalendarConfig.calendars.eventCalendar.fullCalendar("getDate");
            newDate.year($ctrl.ui.selectedYear);
            uiCalendarConfig.calendars.eventCalendar.fullCalendar("gotoDate", newDate);

            newDate = moment(new Date($ctrl.ui.selectedYear, 1));
            $ctrl.yearCalendar.minDate = newDate.startOf("year").toDate();
            $ctrl.yearCalendar.maxDate = newDate.endOf("year").toDate();

            promises.push(marketingTrackerApi.getToken($ctrl.user.UserId)
                .then(function (token) {

                    marketingTrackerAuthService.setAccessToken(token);

                    return userApi.getFigAuth($ctrl.ui.selectedUser.UserId)
                        .then(function (figAuthUser) {

                            var subPromises = [];

                            for (var i = 1; i <= 12; i++)
                                subPromises.push(getMarketingTrackerEventsForFigAuthUser(figAuthUser.FigAuthUserId, $ctrl.ui.selectedYear, i)
                                    .then(function (events) {
                                        $ctrl.allMarketingTrackerEvents = $ctrl.allMarketingTrackerEvents
                                            .concat(events);
                                    }));

                            return $q.all(subPromises);
                        });
                }));

            promises.push(marketingTrackerArcEventApi.getArcEvents().catch(ng.noop)
                .then(function (events) {

                    events = events || [];
                    var data = [];

                    ng.forEach(events,
                        function (event) {

                            data.push({
                                EventGroup: {
                                    TypeId: "FIG Event",
                                    EventType: {
                                        Name: "FIG Event",
                                        Id: "FIG Event"
                                    }
                                },
                                Title: event.Title,
                                Location: event.Location,
                                EventDate: event.EventDate,
                                EventType: {
                                    Name: "FIG Event",
                                    Id: "FIG Event"
                                }
                            });
                        });

                    return $ctrl.allMarketingTrackerEvents = $ctrl.allMarketingTrackerEvents.concat(data);
                }));

            promises.push(getRecommendations());

            $q.all(promises)
                .then(function() {
                    colorCodeEventTypes();
                    convertFullCalendarEvents();
                    calcEventCountsPerYear();
                    uiCalendarConfig.calendars.eventCalendar.fullCalendar("removeEvents");
                    uiCalendarConfig.calendars.eventCalendar.fullCalendar("addEventSource",
                        $ctrl.eventSource);
                    uiCalendarConfig.calendars.eventCalendar.fullCalendar("render");
                    $ctrl.ui.loading = false;
                });
        }

        function _initQueryParams() {

            var setDefaultParams = function () {
                var date = moment();
                $ctrl.startDate = date.toDate();
                stateHistory.setQuery({
                    view: "month",
                    date: date.format("YYYY-MM-DD")
                });
            };

            var params = $location.search();
            if (params.view && params.date) {
                var m = moment(params.date);
                if (params.view === "year") {
                    $ctrl.ui.calendarView = "year";
                    $ctrl.ui.selectedYear = m.year();
                }
                else if ($ctrl.views.fromUrl[params.view]) {
                    $ctrl.ui.calendarView = params.view;
                    $ctrl.ui.selectedYear = m.year();
                    $ctrl.eventCalendar.defaultView = $ctrl.views.fromUrl[params.view];
                    $ctrl.eventCalendar.defaultDate = m;
                } else setDefaultParams();
            } else setDefaultParams();
        }

        $ctrl.$onInit = function () {

            $ctrl.ui.loading = true;

            _initQueryParams();

            marketingTrackerApi.getToken($ctrl.user.UserId)
                .then(function (token) {

                    marketingTrackerAuthService.setAccessToken(token);
                    $ctrl.ui.selectedUser = $ctrl.user;

                    if ($ctrl.onBehalfOfUser) {
                        $ctrl.ui.selectedUser = {
                            UserId: $ctrl.onBehalfOfUser.Id,
                            User: $ctrl.onBehalfOfUser
                        };
                    }

                    userApi.getFigAuth($ctrl.ui.selectedUser.UserId)
                        .then(function (figAuthUser) {

                            marketingTrackerAgentApi.getForFigAuth(figAuthUser.FigAuthUserId)
                                .then(function (agent) {

                                    for (var i = 2015; i <= moment().year() + 2; i++)
                                        if (!_.find($ctrl.years, function (row) { return row === i; }))
                                            $ctrl.years.push(i);

                                    marketingTrackerEventTypeApi.getEventTypesForUser(agent.UserId)
                                        .then(function (types) {

                                            $ctrl.eventTypes = types;
                                            $ctrl.eventTypes.push({
                                                Name: "FIG Event",
                                                Id: "FIG Event"
                                            });

                                            getUserMarketingTrackerEventsForYear();
                                        });
                                });
                        });
                });
        };
    }

})(window.app, window.angular); //jshint ignore:line